(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/payfooter.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/payfooter.js');
'use strict';

class Default extends svs.tur.Base {
  constructor(_ref) {
    let {
      sum = null,
      balance = null,
      buttons = [],
      text = [],
      autoReminder = false,
      reminderOptions,
      calculateParent = '',
      calculateParentElements = svs.tur.payfooter.PARENT_ELEMENTS
    } = _ref;
    super({
      sum,
      balance,
      buttons,
      text,
      autoReminder,
      calculateParent,
      calculateParentElements
    });
    this._elements = [];
    this.createDomElements();
    this.$el.classList += ' dots dots-tur grid-row';
    if (sum) {
      this.trigger(svs.tur.payfooter.SUM_UPDATED, {
        amount: sum.amount,
        animate: false
      });
    }
    if (balance) {
      this.trigger(svs.tur.payfooter.BALANCE_UPDATED, {
        amount: balance.amount,
        animate: false
      });
    }
    if (calculateParent && calculateParentElements) {
      this.parentHeightAttach();
    }
    this.reminder = new svs.tur.payfooter_reminder(reminderOptions);
  }
  createDomElements() {
    this.$inner = this.createElement('payfooter-inner');
    if (this.balance) {
      if (typeof this.balance.addEventHandler === 'function') {
        this.balance.addEventHandler(this);
      }
      this.append(this.balance.render());
    }
    if (this.sum) {
      if (typeof this.sum.addEventHandler === 'function') {
        this.sum.addEventHandler(this);
      }
      this.append(this.sum.render());
    }
    if (this.buttons.length) {
      for (let i = 0; i < this.buttons.length; i++) {
        const btn = this.buttons[i];
        if (typeof btn.addEventHandler === 'function') {
          btn.addEventHandler(this);
        }
        this.$inner.appendChild(btn.$el);
        this._elements.push(btn.$el);
      }
    }
    this.updateText();
    this.$el.appendChild(this.$inner);
  }
  append(el) {
    if (el) {
      this.$inner.appendChild(el);
      this._elements.push(el);
    }
  }
  classNames() {
    const classes = ['payfooter', 'payfooter-default'];
    if (this.calculateParent && this.calculateParent !== 'undefined') {
      classes.push('payfooter-bottom');
    }
    return classes;
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    return this.$el;
  }
  animate() {
    const tl = gsap.timeline({
      delay: 0.1
    });
    tl.fromTo(this.$el, {
      opacity: 0
    }, {
      duration: 0.2,
      opacity: 1,
      clearProps: 'all'
    });
    for (let i = 0; i < this._elements.length; i++) {
      const el = this._elements[i];
      tl.fromTo(el, {
        opacity: 0,
        scale: 0.8
      }, {
        duration: 0.2,
        opacity: 1,
        scale: 1,
        clearProps: 'all'
      }, '-=.15');
    }
    return tl;
  }
  updateSum(_ref2) {
    let {
      amount = 0,
      animate = true,
      text = ''
    } = _ref2;
    this._sum = amount;
    this.trigger(svs.tur.payfooter.SUM_UPDATED, {
      amount,
      animate,
      text
    });
    if (animate && this.autoReminder) {
      this.showReminder();
    }
  }
  updateBalance(_ref3) {
    let {
      amount = 0,
      animate = true,
      text = '',
      forceDim
    } = _ref3;
    this._balance = amount;
    this.trigger(svs.tur.payfooter.BALANCE_UPDATED, {
      amount,
      animate,
      text,
      forceDim
    });
    if (animate && this.autoReminder) {
      this.showReminder();
    }
  }
  updateText() {
    let {
      text = this.text
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      text: this.text
    };
    const paragraphClass = 'payfooter-text';
    const nodesToDelete = this.$inner.getElementsByClassName(paragraphClass);
    for (let i = 0; i < nodesToDelete.length; i++) this.$inner.removeChild(nodesToDelete[i]);
    if (text.length) {
      for (let i = 0; i < text.length; i++) {
        const paragraph = text[i];
        this.$inner.insertAdjacentHTML('beforeend', "<p class=\"".concat(paragraphClass, "\">").concat(paragraph, "</p>"));
      }
    }
  }
  showReminder() {
    let leaveReminder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!this.inViewPort()) {
      this.reminder.show(null, leaveReminder);
    }
  }
  hideReminder() {
    this.reminder.hide();
  }
  inViewPort() {
    const bounding = this.$el.getBoundingClientRect();
    const boundingBottomAdjustment = 50;
    return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + boundingBottomAdjustment && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
  }
  parentHeightAttach() {
    window.addEventListener('resize', _.debounce(() => {
      this.parentHeightSet();
    }));
    window.dispatchEvent(new Event('resize'));
  }
  parentHeightSet() {
    const height = this.parentHeightCalculate();
    const targetEl = document.querySelector(this.calculateParent);
    if (height && targetEl) {
      targetEl.style.height = "calc(100vh - ".concat(height, "px");
      targetEl.style.position = 'relative';
    }
  }
  parentHeightCalculate() {
    let totalHeight = 0;
    const parentElements = document.querySelectorAll(this.calculateParentElements);
    for (let i = 0, len = parentElements.length; i < len; i++) {
      totalHeight += parentElements[i].offsetHeight;
    }
    return totalHeight;
  }
}
svs.tur.payfooter.Default = Default;
svs.tur.payfooter.BUTTON_PAY = 'payfooter:button:pay';
svs.tur.payfooter.BUTTON = 'payfooter:button';
svs.tur.payfooter.SUM_UPDATED = 'payfooter:sum:updated';
svs.tur.payfooter.BALANCE_UPDATED = 'payfooter:balance:updated';
svs.tur.payfooter.PARENT_ELEMENTS = ['.js-fixed-top-content', '.tabs-game-navigation', '.games-navigation-wrapper'];

 })(window);